// @ts-nocheck
import {FC} from 'react'
import {ColumnInstance} from 'react-table'
import {CompanyResponse} from "@providers/company/_models";

type Props = {
  column: ColumnInstance<any>
}

const CustomHeaderColumn: FC<Props> = ({column}) => (
  <>
    {column.Header && typeof column.Header === 'string' ? (
      <th style={{cursor:"none"}} {...column.getHeaderProps()}>{column.render('Header')}</th>
    ) : (
      column.render('Header')
    )}
  </>
)

export {CustomHeaderColumn}
